module.exports = new __parcel__URL__("business-board-empty-state-darkmode.137379d7.svg").toString();